function initSlider(slider, nextButton, prevButton) {
    new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 30,
        keyboard: {
            enabled: true,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2.5,
                spaceBetween: 10
            },
            // when window width is >= 640px
            768: {
                slidesPerView: 4,
                spaceBetween: 10
            },
            991: {
                slidesPerView: 4,
                spaceBetween: 30
            }
        },
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        }
    });
}
function initListrak() {
  if(document.querySelectorAll('.listrak-overflow').length) {
    /********** Begin Custom Code **********/
    _ltk.Recommender.AddField("Meta3");
    _ltk.Recommender.AddField("Sku");
    _ltk.Recommender.Render();

    
    document.querySelectorAll('.listrak-overflow').forEach((container) => {
      const slider = container.querySelector('.list-rec__slider');
      const nextButton = container.querySelector('.swiper-button-next');
      const prevButton = container.querySelector('.swiper-button-prev');

      if (slider && nextButton && prevButton) {
        initSlider(slider, nextButton, prevButton);
      }
    });
}
}


(function(d) { if (document.addEventListener) document.addEventListener('ltkAsyncListener', d);
  else {e = document.documentElement; e.ltkAsyncProperty = 0; e.attachEvent('onpropertychange', function (e) {
  if (e.propertyName == 'ltkAsyncProperty'){d();}});}})(function() {

      /********** Begin Custom Code **********/
      if (Shopify.designMode) {
        initListrak();
        document.addEventListener("shopify:section:load", function(event) {
          if(event.srcElement.className.includes('listrak-overflow')) {
            initListrak();
          }
        });
      } else {
        initListrak();
      }
});